module.exports = __webpack_public_path__ + "img/member4.49a483c.jpg";